import http from 'hub-http/clients/apiClient';
import { getEarlyRequestByKey } from 'FormsUI/utils/earlyRequestUtils';
export const QUICK_FETCH_INVENTORY_KEY = 'InventoryRequests';
const fetchInventory = () => http.get('customer-inventory/v1/inventory/');
export const getInventory = () => getEarlyRequestByKey(QUICK_FETCH_INVENTORY_KEY, fetchInventory).catch(() => {
  return {
    products: []
  };
});